const FILTER_KEY = 'filter';

/**
 * Remove sessionStorage['filter']. Espelha `AuthService.cleanFilter`; disparado
 * antes de navegar para que a próxima tela não herde o filtro da tela anterior.
 */
export function cleanFilter(): void {
  try {
    sessionStorage.removeItem(FILTER_KEY);
  } catch {
    // Storage indisponível — best-effort.
  }
}

/**
 * Abre um link externo em nova aba, preservando a aba atual. `noopener,noreferrer`
 * evita que a nova aba tenha acesso a `window.opener`.
 */
export function openExternal(path: string): void {
  window.open(path, '_blank', 'noopener,noreferrer');
}
